module.exports = __webpack_public_path__ + "assets/adcc12b76b5f379b072d9ba4d47152ad.mp3";